import { render, staticRenderFns } from "./QuestionnaireForm.vue?vue&type=template&id=10afeeee&scoped=true&"
import script from "./QuestionnaireForm.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireForm.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireForm.vue?vue&type=style&index=0&id=10afeeee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10afeeee",
  null
  
)

export default component.exports